import { render, staticRenderFns } from "./Calculate.vue?vue&type=template&id=dbfc31e6&scoped=true&"
import script from "./Calculate.vue?vue&type=script&lang=js&"
export * from "./Calculate.vue?vue&type=script&lang=js&"
import style0 from "./Calculate.vue?vue&type=style&index=0&id=dbfc31e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbfc31e6",
  null
  
)

export default component.exports